/** Bucket key for rows whose geo could not be resolved — either the partner join (`partnerId` →
 *  `ICockpitPartnerData`) or the geo-mapping tree lookup came up empty. Also shared with
 *  `getCockpitInitiativeHierarchyRows.ts`, which imports it straight from this file. */
export const UNMAPPED_GEO_KEY = 'unmapped'

/** Raw fallback label for the Unmapped geo bucket, same caveat as `UNMAPPED_GEO_KEY`. */
export const UNMAPPED_GEO_LABEL = 'Unmapped'

/** Sorts the Unmapped bucket after every real geo node. */
export const UNMAPPED_GEO_ORDER = Number.MAX_SAFE_INTEGER

/** Fallback for a product node whose offering isn't present in the offering→order map — sorts it
 *  after every offering the map does know about. Shouldn't happen in practice since the map is
 *  built from the same catalog the rows themselves come from. */
export const UNKNOWN_OFFERING_ORDER = Number.MAX_SAFE_INTEGER

/** Fixed sentinel for the grand Total row's `rowId`, manager cockpit mode (Geo axis enabled) only —
 *  deliberately never derived from a composed `productKey`/`geoKey` pair, so it can never collide
 *  with a real node's own id. */
export const TOTAL_ROW_ID = '__total__'
